// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiMedical {
    'groupName'?: string;
    'groupPhone'?: string;
    'policyAvailableOnWebsite'?: string;
    'policyNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiMedical>> = [
        {
            "name":     "groupName",
            "baseName": "groupName",
            "type":     "string"
        },
        {
            "name":     "groupPhone",
            "baseName": "groupPhone",
            "type":     "string"
        },
        {
            "name":     "policyAvailableOnWebsite",
            "baseName": "policyAvailableOnWebsite",
            "type":     "string"
        },
        {
            "name":     "policyNumber",
            "baseName": "policyNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiMedical.attributeTypeMap;
    }
}
